import {getSiteUrl} from "@/helpers/functions";

export interface SeoSchemaServiceProps {
    name: string;
    description: string;
    serviceType?: string;
    areaServed?: string[];
    url: string;
}

const toAbsoluteUrl = (siteUrl: string, url: string): string => {
    if (/^https?:\/\//i.test(url)) return url;
    return `${siteUrl}${url.startsWith("/") ? "" : "/"}${url}`;
};

export function SeoSchemaService({name, description, serviceType, areaServed, url}: SeoSchemaServiceProps) {
    const siteUrl = getSiteUrl();
    const schema: Record<string, unknown> = {
        "@context": "https://schema.org",
        "@type": "Service",
        "name": name,
        "description": description,
        "url": toAbsoluteUrl(siteUrl, url),
        "provider": {"@id": `${siteUrl}/#organization`},
    };
    if (serviceType) schema.serviceType = serviceType;
    if (areaServed && areaServed.length > 0) schema.areaServed = areaServed;
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}}
        />
    );
}
